import DividerLine from './DividerLine';

export default DividerLine;
